export default __webpack_public_path__ + "static/media/574.2ce5ef7e.png";